import { ConfigurationType, ConfigurationToName } from '../dependencies/types';

export const configurationTypesOptions = [
  {
    value: ConfigurationType.apexClasses,
    label: ConfigurationToName[ConfigurationType.apexClasses],
  },
  {
    value: ConfigurationType.apexTriggers,
    label: ConfigurationToName[ConfigurationType.apexTriggers],
  },
  {
    value: ConfigurationType.approvalProcesses,
    label: ConfigurationToName[ConfigurationType.approvalProcesses],
  },
  { value: ConfigurationType.fields, label: ConfigurationToName[ConfigurationType.fields] },
  { value: ConfigurationType.flows, label: ConfigurationToName[ConfigurationType.flows] },
  {
    value: ConfigurationType.objects,
    label: ConfigurationToName[ConfigurationType.objects],
  },
  { value: ConfigurationType.layouts, label: ConfigurationToName[ConfigurationType.layouts] },
  {
    value: ConfigurationType.recordTypes,
    label: ConfigurationToName[ConfigurationType.recordTypes],
  },
  {
    value: ConfigurationType.processBuilderFlows,
    label: ConfigurationToName[ConfigurationType.processBuilderFlows],
  },
  {
    value: ConfigurationType.validationRules,
    label: ConfigurationToName[ConfigurationType.validationRules],
  },
  {
    value: ConfigurationType.workflowRules,
    label: ConfigurationToName[ConfigurationType.workflowRules],
  },
];

//regexp adding space between lowerCase and capital letters
export const formatCamelCase = (text: string) => text.replace(/([a-z])([A-Z])/g, '$1 $2');
